import { useQuery } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';

const useCsrfCookie = (enabled: boolean = true) => {
  const queryKey = ['csrf-cookie'];

  const queryFn = async () => {
    return getCookie();
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
    retry: false,
  });
};

export default useCsrfCookie;

async function getCookie() {
  await BackendClient.get('/sanctum/csrf-cookie');

  return true; // Return true to indicate the cookie has been set
}
